document.addEventListener('alpine:init', () => {
  Alpine.data('CartUpsell', () => ({
    isAddingUpsell: false,
    errorMessage: '',

    async addUpsellToCart(variantId) {
      console.log('Attempting to add upsell product with variant ID:', variantId);
      
      if (!variantId) {
        console.error('No variant ID provided');
        this.errorMessage = 'Product could not be added (no variant selected)';
        return;
      }
      
      if (this.isAddingUpsell) {
        console.log('Already adding product to cart, ignoring request');
        return;
      }
      
      this.isAddingUpsell = true;
      this.errorMessage = '';
      const sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

      const config = fetchConfigDefaults('javascript');
      config.body = JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }],
        sections,
        sections_url: window.location.pathname
      });

      try {
        console.log('Sending request to add item to cart');
        const response = await fetch(theme.routes.cart_add_url, config);
        const data = await response.json();
        console.log('Response received:', data);

        if (data.status) {
          // Error occurred
          console.error('Error adding upsell product:', data.description);
          this.errorMessage = data.description || 'Could not add product to cart';
        } else {
          // Success
          console.log('Product successfully added to cart');
          document.body.dispatchEvent(
            new CustomEvent('shapes:modalcart:afteradditem', {
              bubbles: true,
              detail: { response: data }
            })
          );
        }
      } catch (error) {
        console.error('Error:', error);
        this.errorMessage = 'An unexpected error occurred';
      } finally {
        this.isAddingUpsell = false;
      }
    }
  }));
});